import React from "react";
import "./StatusConciliation.scss";


const StatusConciliation = ({ colorComercial, colorFiscal }) => {


    const stylesComercial = { backgroundColor: colorComercial };  
    const stylesFiscal = { backgroundColor: colorFiscal };

    return (
        <div className="status-conciliation">
            <span className="colored-circle" style={stylesComercial} />
            <span className="colored-circle-2" style={stylesFiscal} />
        </div>
    )
};

export default StatusConciliation;